import { Routes, Route, Navigate  } from 'react-router-dom';
import FormOptions from './initial-form';
import EditFormSelection from './edit-form';
import CustomFormBuilder from './create-form';

const FormManagement = () => {
  return (
    <Routes>
      <Route path="/" element={<FormOptions />} />
      <Route path="new" element={<CustomFormBuilder />} />
      <Route path="edit" element={<EditFormSelection />} />
      <Route path="edit/:id" element={<CustomFormBuilder />} />
      {/* Fallback route */}
      <Route path="*" element={<Navigate to="/custom-form" />} />
    </Routes>
  );
};

export default FormManagement;